import { GridOptions } from "ag-grid-community";

export class GlobalsServiceConfig
{
    CatchHttpErrorsGlobal: boolean;
    GridOptions: GridOptions;
    InfiniteScroolGridOptions: GridOptions;
}


// WEBPACK FOOTER //
// ./src/app/shared/globals.config.ts